import React, {useState} from 'react'
import Text from 'react-text'
import {Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import {confirmAlert} from 'react-confirm-alert'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import {saveTemplate, saveRDTemplate} from '../../../context/post'
import {isEmpty} from '../../../helpers/utils'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const useStyles = makeStyles({
  add: {
    color: '#4e576e',
    background: '#fff',
    textTransform: 'none',
    '&:hover': {
      background: '#eaf5ff'
    }
  },
  item: {
    minWidth: '200px',
    color: '#4e576e',
    padding: '10px',
    '&:hover': {
      color: '#fff',
      background: '#2993ff'
    }
  }
})

function SaveTemplateDialog (props) {
  const {context, plan, onClose, rd=undefined} = props
  const {translate, setState, assessmentUpdates} = context
  const [name, setName] = useState(plan.title || "") 
  const canSave = ! isEmpty(name)
  return (
    <div className="save-template-dialog">
      <div className="title">
        {translate('save_template_label')}
      </div>
      <div className="input">
        <input
          value={name}
          type="text"
          onChange={e => setName(e.target.value)}
        />
      </div>
      <div className="buttons">
        <button
          className="save button"
          disabled={!canSave}
          onClick={() => {
            if(rd){
              saveRDTemplate(name, plan).then(() => setState({templateUpdates: context.templateUpdates + 1}, onClose))
              return
            }
            saveTemplate(name, plan).then(() => setState({templateUpdates: context.templateUpdates + 1}, onClose))
          }}
        >
          {context.translate('save_label')}
        </button>
        <div className="cancel button" onClick={onClose}>
          {translate('cancel_label')}
        </div>
      </div>
    </div>
  )
}

function saveTemplateDialog (props) {
  return confirmAlert({
    customUI: ({onClose}) => (<SaveTemplateDialog {...{...props, onClose}}/>)
  })
}


export default function TemplatesMenu(props) {

  const {context, plan, rd=undefined} = props
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)

  function handleClick(event) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <div className="templates-menu">
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        className={classes.add}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        <Text id="templates_label" />
      </Button>
      <Menu
        elevation={0}
        getContentAnchorEl={null}
        className={classes.menu}
        anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
        transformOrigin={{vertical: 'top', horizontal: 'left'}}
        id="add-field-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem disableGutters={true} className={classes.item} onClick={() => {
          saveTemplateDialog({context, plan, rd})
          handleClose()
        }}>
          <Text id="save_as_template" />
        </MenuItem>
        <MenuItem disableGutters={true} className={classes.item}>
          <Link className="manage-templates" to={context.link({},`${context.match.path}/templates`,{preserveQuery: true})}>
            <Text id="manage_templates" />
          </Link>
        </MenuItem>
      </Menu>
    </div>
  )
}
